
import angular from 'angular';
import { DatalayerUtils } from 'src/app/shared/ib-datalayer-utils';
import { DatalayerConstantsType } from 'ib-web-commons/app/core/ib-datalayer/ib-datalayer-constants';

const controllerInfo = {
    module: 'ib-seat-map-module',
    inject: ['$uibModalInstance', 'object', '$rootScope', 'DatalayerUtilsService', 'DatalayerUtils', 'CommonsConstants', 'localStorageService', 'AncillariesConstants', 'CommonsUtilService', 'DatalayerConstants'],
    required: []
};


export class ConfirmationSeatMapModalController implements ng.IController {

    public model;
    constructor (
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        private object: any,
        private $rootScope: CommonsRootScope,
        private DatalayerUtilsService: DatalayerUtilsService,
        private DatalayerUtils: DatalayerUtils,
        private CommonsConstants: CommonsConstantsType,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private AncillariesConstants: AncillariesConstant,
        private CommonsUtilService: CommonsUtilService,
        private DatalayerConstants: DatalayerConstantsType) {
        this.model = object;
    }

    updateDataLayerAndDigitalData = (): void => {
        const flow = this.localStorageService.get('flowApp');
        let quadrigam = '';
        switch (flow) {
                case this.AncillariesConstants.APPLICATION_FLOW.BBOOKING:
                case this.AncillariesConstants.APPLICATION_FLOW.BOOKING:
                    quadrigam = this.CommonsConstants.STEP_FLOW.ANCILLARIES.toUpperCase();
                    break;
                case this.AncillariesConstants.APPLICATION_FLOW.CHECKIN:
                    quadrigam = this.AncillariesConstants.QUADRIGAM.ANCILLARIES;
                    break;
        }
        /* INIT DELETE GA4 MIGRATION */
        this.DatalayerUtilsService.updateDatalayerWithQuadrigam(quadrigam, null, this.localStorageService.get('userLogged'));
        this.DatalayerUtilsService.setProcessAndStep(this.CommonsUtilService.getProcess(), this.DatalayerConstants.DATALAYER_ANCILLARIES.ANCILLARIES, quadrigam);
        this.DatalayerUtilsService.sendDatalayerEvent(this.DatalayerConstants.DATALAYER_EVENT_TYPES.VIEW);
        /* FINISH DELETE GA4 MIGRATION*/
        this.DatalayerUtilsService.updateDigitalDataWithQuadrigam(quadrigam, null, this.localStorageService.get('userLogged'));
        this.DatalayerUtilsService.updateDatalayerViewEvent();
    };

    accept = (): void => {
        const flow = this.localStorageService.get('flowApp');
        this.DatalayerUtils.setSeatAddToCart(this.model);
        this.$rootScope.$broadcast('acceptSeats');
        this.$uibModalInstance.close();
        this.$rootScope.$broadcast('updateDatalayer');
        this.$rootScope.$broadcast('updatePageType');
        if(flow !== this.AncillariesConstants.APPLICATION_FLOW.MMB) {
            this.updateDataLayerAndDigitalData();
        }
    };

    close = (): void => {
        const flow = this.localStorageService.get('flowApp');
        this.$uibModalInstance.dismiss();
        this.$rootScope.$broadcast('updateDatalayer');
        this.$rootScope.$broadcast('updatePageType');
        if(flow !== this.AncillariesConstants.APPLICATION_FLOW.MMB) {
            this.updateDataLayerAndDigitalData();
        }
    };


    /**
     * Close window and open seat map of segment selected to modify
     * @param {*} segmentId
     */
    modifySegment = (segmentId): void => {
        this.$rootScope.$broadcast('modifySeatMap', segmentId);
        this.$uibModalInstance.close();
    };

}



try {
    ConfirmationSeatMapModalController.$inject = controllerInfo.inject;
    angular.module(controllerInfo.module).controller(ConfirmationSeatMapModalController.name, ConfirmationSeatMapModalController);

} catch (error) {
    const mod = angular.module(controllerInfo.module, controllerInfo.required);
    ConfirmationSeatMapModalController.$inject = controllerInfo.inject;
    mod.controller(ConfirmationSeatMapModalController.name, ConfirmationSeatMapModalController);
}